import React, {useState} from "react";
import useWindowSize from '../../../hooks/useWindowSize';

//Images
import netLogoBSC from '../asset/images/binance.png';
import netLogoPOLY from '../asset/images/polygon.png';
import netLogoETH from '../asset/images/eth.png';
import netLogoARB from '../asset/images/arb.png';
import netLogoBase from '../asset/images/base-1.png';
import netLogoAvax from '../asset/images/avax.png';
import netLogoKaia from '../asset/images/kaia.png';
import { useActiveWeb3React } from "../../../hooks";
import networkChange from "../../../utils/networkChange";
import { CHAINID_FULLNAME, MAPPING_CHAINID } from "../../../constants";
import { useWeb3ModalState } from "@web3modal/wagmi/react";
import { useAccount } from "wagmi";

const CrossChain = () => {
    const [isShow, setIsShow] = useState(false);
    
    const { selectedNetworkId } = useWeb3ModalState()
    const chainId = selectedNetworkId;
    const { address, isConnected } = useAccount();

    const size = useWindowSize();
    const sizeTablet = 1024;
     
    let netName = '';
    let netLogo = '';
    switch (chainId) {
        case 56:
            netName = CHAINID_FULLNAME.bsc;
            netLogo = netLogoBSC;
            break;
        case 137:
            netName = CHAINID_FULLNAME.poly;
            netLogo = netLogoPOLY;
            break;
        case 1:
            netName = CHAINID_FULLNAME.eth;
            netLogo = netLogoETH;
            break;
        case 42161:
            netName = CHAINID_FULLNAME.arb;
            netLogo = netLogoARB;
            break;
        case 421613:
            netName = CHAINID_FULLNAME.arbtestnet;
            netLogo = netLogoARB;
            break;
        case 8453:
            netName = CHAINID_FULLNAME.base;
            netLogo = netLogoBase;
            break;
        case 43114:
            netName = CHAINID_FULLNAME.avax;
            netLogo = netLogoAvax;
            break;
        case 8217:
            netName = CHAINID_FULLNAME.kaia;
            netLogo = netLogoKaia;
            break;
        default:
            netName = 'BSC';
            netLogo = netLogoBSC;
    }

    const handleCrossChainSP = () => {
        if(size.width <= sizeTablet) {
            setIsShow(!isShow);
        } else {
            setIsShow(false);
        }
    }
    
    return(
        <div className="c-crossChain">
            <div className="c-crossChain__showName" onClick={() => handleCrossChainSP()}><img src={netLogo} alt={netName} />{netName}</div>
            <ul className={`c-crossChain__list${isShow ? ' is-showChain' : ''}`}>
                <li onClick={() => networkChange(MAPPING_CHAINID.bsc)}><img src={netLogoBSC} alt=""/>BSC</li>
                <li onClick={() => networkChange(MAPPING_CHAINID.poly)}><img src={netLogoPOLY} alt=""/>Polygon</li>
                <li onClick={() => networkChange(MAPPING_CHAINID.eth)}><img src={netLogoETH} alt="" />Ethereum</li>
                <li onClick={() => networkChange(MAPPING_CHAINID.base)}><img src={netLogoBase} alt="" />Base</li>
                <li onClick={() => networkChange(MAPPING_CHAINID.avax)}><img src={netLogoAvax} alt="" />Avalanche C-Chain</li>
                <li onClick={() => networkChange(MAPPING_CHAINID.kaia)}><img src={netLogoKaia} alt="" />Kaia</li>
                {process.env.REACT_APP_MODE === "production" &&  <li onClick={() => networkChange(MAPPING_CHAINID.arb)}><img src={netLogoARB} alt="" />Arbitrum</li>} 
                {process.env.REACT_APP_MODE === "development" && 
                <> 
                    <li onClick={() => networkChange(MAPPING_CHAINID.arb)}><img src={netLogoARB} alt="" />Arbitrum</li>
                    <li onClick={() => networkChange(MAPPING_CHAINID.arbtestnet)}><img src={netLogoARB} alt="" />ArbitrumTEST</li>
                </>
                }
               
            </ul>
        </div>
    );
}

export default CrossChain;